import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  LabelValueContainer,
  Label,
  Value,
  ProfilePic,
  ProfilePicContainer,
} from "../../CasesTable/styles";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../../helpers/functions";
import labels from "../../../../helpers/labels.json";
import SystemService from "../../../../services/SystemService";
import Modal from "./Modal";

export default function DrawerModal({
  modal,
  setModal,
  id,
  type = "Case manager",
  details = {},
}) {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [userDetails, setUserDetails] = useState({});
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    async function getUserUserInfo() {
      try {
        setLoader({ state: true, message: "Getting user information" });
        const res = await SystemService.getProfile(id);
        if (res) {
          setUserDetails(res);
          setOpenModal(true);
        }
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
    if (id && modal && (type === "Mediator" || type === "Arbitrator")) {
      getUserUserInfo();
    } else {
      setUserDetails(details);
      setOpenModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, modal]);

  const handleClose = () => {
    setOpenModal(false);
    setModal(false);
  };

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      title={type}
      subtitle={`${
        userDetails?.role
          ? userDetails.role.charAt(0).toUpperCase() + userDetails.role.slice(1)
          : type
      } Details`}
      width={680}
    >
      <ModalBody>
        <>
          <ProfilePicContainer>
            <ImageWrapper>
              <ProfilePic
                src={
                  userDetails?.avatarUrl
                    ? userDetails?.avatarUrl
                    : require("../../../../../src/assets/images/userPlaceholder.svg")
                }
              ></ProfilePic>
            </ImageWrapper>
          </ProfilePicContainer>
          {type === "Mediator" || type === "Arbitrator" ? (
            <>
              <BasicDetails>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["user.name"]}</Label>
                    <Value>{userDetails?.name}</Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["user.email"]}</Label>
                    <Value>{userDetails?.email}</Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["user.mobile"]}</Label>
                    <Value>{userDetails?.mobile}</Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.qualification"]}</Label>
                    <Value>
                      {userDetails?.qualification
                        ? userDetails?.qualification
                        : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.yearsOfExperience"]}</Label>
                    <Value>
                      {userDetails?.experience ? userDetails?.experience : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.language"]}</Label>
                    <Value>
                      {userDetails?.languagesKnown
                        ? userDetails?.languagesKnown
                        : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.affiliatedOrg"]}</Label>
                    <Value>
                      {userDetails?.affiliatedOrg
                        ? userDetails?.affiliatedOrg
                        : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.location"]}</Label>
                    <Value>
                      {userDetails?.location ? userDetails?.location : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.specialities"]}</Label>
                    <Value>
                      {userDetails?.specialities
                        ? userDetails?.specialities
                        : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                <LabelContainer>
                  <LabelValueContainer style={{ width: "auto" }}>
                    <Label>{labels["mediator.tagLine"]}</Label>
                    <Value>
                      {userDetails?.tagLine ? userDetails?.tagLine : "-"}
                    </Value>
                  </LabelValueContainer>
                </LabelContainer>
                {userDetails?.alternateMobileNumber?.length ? (
                  <LabelContainer>
                    <LabelValueContainer style={{ width: "auto" }}>
                      <Label>{labels["mediator.alternateMobileNumber"]}</Label>
                      <Value>{userDetails?.alternateMobileNumber}</Value>
                    </LabelValueContainer>
                  </LabelContainer>
                ) : null}
                {userDetails?.institutionOfMediationTraining?.length ? (
                  <LabelContainer>
                    <LabelValueContainer style={{ width: "auto" }}>
                      <Label>
                        {labels["mediator.institutionOfMediationTraining"]}
                      </Label>
                      <Value>
                        {userDetails?.institutionOfMediationTraining}
                      </Value>
                    </LabelValueContainer>
                  </LabelContainer>
                ) : null}
                {userDetails?.numberOfMediationsConducted?.length ? (
                  <LabelContainer>
                    <LabelValueContainer style={{ width: "auto" }}>
                      <Label>
                        {labels["mediator.numberOfMediationsConducted"]}
                      </Label>
                      <Value>{userDetails?.numberOfMediationsConducted}</Value>
                    </LabelValueContainer>
                  </LabelContainer>
                ) : null}
              </BasicDetails>
              <LabelContainer>
                <LabelValueContainer style={{ width: "auto" }}>
                  <Label>{labels["mediator.shortbio"]}</Label>
                  <Value>
                    {userDetails?.shortBio ? userDetails?.shortBio : "-"}
                  </Value>
                </LabelValueContainer>
              </LabelContainer>
            </>
          ) : (
            <BasicDetails>
              <LabelContainer>
                <LabelValueContainer style={{ width: "auto" }}>
                  <Label>{labels["user.name"]}</Label>
                  <Value>{userDetails?.name}</Value>
                </LabelValueContainer>
              </LabelContainer>

              <LabelContainer>
                <LabelValueContainer style={{ width: "auto" }}>
                  <Label>{labels["user.email"]}</Label>
                  <Value>{userDetails?.email}</Value>
                </LabelValueContainer>
              </LabelContainer>

              <LabelContainer>
                <LabelValueContainer
                  style={{ width: "auto", marginBottom: 20 }}
                >
                  <Label>{labels["user.mobile"]}</Label>
                  <Value>{userDetails?.mobile}</Value>
                </LabelValueContainer>
              </LabelContainer>
            </BasicDetails>
          )}
        </>
      </ModalBody>
    </Modal>
  );
}

const LabelContainer = styled.div`
  margin-right: 20px;
  margin-bottom: 20px;
  @media (min-width: 640px) {
    margin-right: 0;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  max-height: 92vh;
  overflow: auto;

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 91px;
  height: 91px;
  border-radius: 50%;
  margin-bottom: 2px;
  user-select: none;
`;

const BasicDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 10px;
`;
